import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "kt_aside",
  class: "aside aside-hoverable aside-dark",
  "data-kt-drawer": "true",
  "data-kt-drawer-activate": "{default: true, lg: false}",
  "data-kt-drawer-direction": "start",
  "data-kt-drawer-name": "aside",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-toggle": "#kt_aside_mobile_toggle",
  "data-kt-drawer-width": "{default:'200px', '300px': '250px'}"
}
const _hoisted_2 = {
  id: "kt_aside_logo",
  class: "aside-logo flex-column-auto"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  id: "kt_aside_toggle",
  class: "btn btn-icon w-auto px-0 btn-active-color-primary aside-toggle d-none d-lg-flex",
  "data-kt-toggle": "true",
  "data-kt-toggle-name": "aside-minimize",
  "data-kt-toggle-state": "active",
  "data-kt-toggle-target": "body"
}
const _hoisted_5 = { class: "svg-icon svg-icon-1 rotate-180" }
const _hoisted_6 = { class: "aside-menu flex-column-fluid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Menu = _resolveComponent("Menu")!

  return (!_ctx.hasRole('ROLE_FORMS_MOBILE'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                alt: "Logo",
                class: "h-15px logo",
                src: _ctx.logoSrc
              }, null, 8, _hoisted_3)
            ]),
            _: 1
          }),
          _createElementVNode("button", {
            id: "kt_aside_mobile_close",
            class: "btn btn-mobile-close d-lg-none",
            type: "button",
            "aria-label": "Zamknij menu",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeMobileMenu && _ctx.closeMobileMenu(...args)))
          }, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("i", { class: "bi bi-x-lg" }, null, -1)
          ]))]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, [
              _createVNode(_component_inline_svg, { src: "/img/navigation/angle-double-left.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Menu)
        ])
      ]))
    : _createCommentVNode("", true)
}